import { Box, Grid, Typography } from '@mui/material';

import { translateLabel } from 'FRONTEND/utils/translateLabel';

/**
 * A component representing a text field with save functionality.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.saveInformation - A function to save the input value.
 * @param {string} props.id - The ID of the input field.
 * @param {string} props.label - The label for the input field.
 * @returns {JSX.Element} - The rendered TextFieldWithSaveInformation component.
 */
const TextFieldWithSaveInformation = ({ saveInformation, id, label }) => {
  const onChange = (ev) => {
    // Call the saveInformation function with the new input value
    saveInformation({ id, value: ev.target.value });
  };

  return (
    <Box
      className='col-sm-12 form-group' // #2562 Maybe col-sm-[x] needs to be dynamic, unsure if some scenarios need 6 instead of 12.
      sx={{ paddingX: '15px' }}
    >
      <label htmlFor={id}>{label}</label>
      <input
        className='form-control'
        onChange={onChange}
        id={id}
      />
    </Box>
  );
};

/**
 * To work, the fields being repeated needs to be direct children of RepeatableField,
 * hence we need to use a render function instead of a component to render those fields.
 */
export const renderFormFields = ({ field, saveInformation, locale }) => {
  switch (field.component) {
    case 'InputField':
      // Render a text field with save functionality
      return (
        <TextFieldWithSaveInformation
          key={field.id}
          id={field.id}
          label={translateLabel(field.label, locale)}
          saveInformation={saveInformation}
        />
      );
    case 'Section': {
      // Render a section with nested fields
      const fieldsInSection = field.fields.map((field, index) => renderFormFields({ field, saveInformation, locale, key: index }));
      return (
        <Grid item xs={12} key={field.id} className='panel panel-info' sx={{ marginLeft: '0 !important', marginRight: '0 !important', background: 'inherit !important' }}>
          <Box className='panel-heading' sx={{ background: '#f5f5f5 !important' }}>
            <Typography variant='h5' sx={{ fontSize: '18px' }} className='panel-title'>
              {translateLabel(field.label, locale)}
            </Typography>
          </Box>
          <Grid container spacing={1}>
            <Box className='panel-body'>
              <Box className='row' sx={{ marginLeft: '-6px' }}>
                {fieldsInSection}
              </Box>
            </Box>
          </Grid>
        </Grid>
      );
    }
    default:
      // Log a warning for unhandled component types
      console.warn('Component not handled', field.component, field.id);
      return null;
  }
};

